import groupBy from 'lodash/groupBy'

import { BankLine } from '@modules-deprecated/bankReconciliation/types'

interface TransactionGroup {
  date: string
  transactions: BankLine[]
}

export const groupTransactionsByDate = (transactions: BankLine[]): TransactionGroup[] => {
  const transactionsByDate = groupBy(transactions, 'entryDate')

  return Object.entries(transactionsByDate).map(([date, transactions]) => ({ date, transactions }))
}
